import React from 'react';
import { motion } from 'framer-motion';

const Loader = ({ full = false }) => (
  <div className={`flex items-center justify-center ${full ? 'fixed inset-0 z-50' : 'w-full py-20'}`}
    style={{ background: full ? 'var(--dark)' : 'transparent' }}>
    <div className="relative">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 1.2, repeat: Infinity, ease: 'linear' }}
        className="w-14 h-14 rounded-full border-2 border-transparent"
        style={{ borderTopColor: 'var(--red)', borderRightColor: 'rgba(229,9,20,0.3)' }}
      />
      <motion.div
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ duration: 1.2, repeat: Infinity }}
        className="absolute inset-0 flex items-center justify-center"
      >
        <div className="w-3 h-3 rounded-full" style={{ background: 'var(--red)' }} />
      </motion.div>
    </div>
  </div>
);

export default Loader;
